var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-section flex flex-col justify-center"},[_c('div',{staticClass:"relative w-full flex flex-row justify-center"},[_vm._t("default"),_c('div',{staticClass:"absolute bottom-0 text-chplus-s",staticStyle:{"left":"50%","transform":"translate(-50%,100%)","white-space":"nowrap"}},[_vm._t("info")],2)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }